

import { ModelSelect, ModelListSelect  } from 'vue-search-select'
import 'vue-search-select/dist/VueSearchSelect.css'


import vSelect from "vue-select";
// import "vue-select/dist/vue-select.css";




import UMUM from         '../../library/umum'
import FETCHING from  '../../library/fetching'
import FUNCTIONS from  '../../library/function'


const items = [{"id": 1, "name": "Some name"},
{"id": 5, "name": "Another name"}]

export default {
  components: {
     ModelSelect, ModelListSelect, vSelect
  },
  data() {
    return {
      

      form : {
        id : '',
        bentuk : '',
        sifat : '',
        type : 0,
        judul : '',
        perihal : '',
        nomor : '',
        konseptor : '',
        unit_kerja : '',
        penanda_tangan : '',
        status_ttd : '',
        tgl_ttd : '',
        isi : '',
        keterangan : '',
        lampiran : null,
        lampiran_type : '',
        pengagenda : '',
        status_agenda : '',
        tgl_agenda : '',
        status : '',

        status_verifikator : '',
        agenda_nomor : '',
        user_nama : '',


        sm_verifikator_id : '',
        sm_verifikator : '',
      },




      items,
      selectedValue: '22nPYs2bDwNNwides',
      optionsx : [
        {
            title: "HTML5",
            title2: "HTML7",
            author: {
            firstName: "Remy",
            lastName: "Sharp"
            }
        }
        ],





        borang_template :'',
        
        list_data : [],
        list_penandatangan : [],
        list_pemeriksa : [],

        list_penerima : [],
        list_penerima_final : [],

        list_penerima_view : [],
        list_penerima_surat : [],
        list_penerima_surat_final : [],


        filterku : {
            instansi_id : '',
            unit_kerja_id : '',
            unit_kerja_search : '',
            biodata_id :null,
            status_id : '',

            page_limit : 10,
            cari_value : '',
        },


        page_first: 1,
        page_last: 0,
        page_limit : 10,
        cari_value: "",
        cek_load_data : true,



        mdl_fileLampiran: false,
        mdl_viewPenerima: false,
        mdl_viewPemeriksa: false,
        mdl_viewPPenandaTangan: false,
        mdl_penerimaDisposisi : false,
        mdl_penerimaDisposisiAdd : false,

        ambil_semua_unit_kerja : false,





        UMUM : UMUM,
        FETCHING : FETCHING,
        FUNCTIONS : FUNCTIONS,

        fileOld : '',

        step: 1,

        content: 'asdas',
        unit_kerja : '',
    }
  },
  methods: {



    getView : function(){
      // this.$store.commit("shoWLoading");
      this.cek_load_data = true;
      fetch(this.$store.state.url.office_sm_verifikasiDisposisi + "view", {
          method: "POST",
          headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify({
              data_ke: this.page_first,
              page_limit : this.page_limit,
              cari_value: this.cari_value,
              unit_kerja : this.form.unit_kerja,
          })
      })
          .then(res => res.json())
          .then(res_data => {
              this.list_data = res_data.data;
              this.page_last = res_data.jml_data;
              // this.$store.commit("hideLoading");
              this.cek_load_data = false;
              console.log(res_data);
      });
    },

    penerimaSuratAdd : function(){
      fetch(this.$store.state.url.office_sm_verifikasiDisposisi + "penerima", {
          method: "POST",
          headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify({
            form:this.form,
            list_penerima_surat_final : this.list_penerima_surat_final
          })
      }).then(res_data => {
            this.Notify('Sukses Menomori Surat', 'primary', 'check_circle_outline');
            this.selectBiodata('')
      });

      // console.log(this.filterku.biodata_id)
    },




    selectData : function(data){
        // console.log(data)
        this.form.id = data.id
        this.form.bentuk = data.bentuk
        this.form.sifat = data.sifat
        this.form.type = data.type
        this.form.judul = data.judul
        this.form.perihal = data.perihal
        this.form.nomor = data.nomor
        this.form.konseptor = data.konseptor
        this.form.unit_kerja = data.unit_kerja
        this.form.penanda_tangan = data.penanda_tangan
        this.form.status_ttd = data.status_ttd
        this.form.tgl_ttd = data.tgl_ttd
        this.form.isi = data.isi
        this.form.keterangan = data.keterangan
        // this.form.lampiran = data.lampiran
        this.fileOld = data.lampiran
        // this.form.fileOld = data.lampiran

        this.form.lampiran_type = data.lampiran_type
        this.form.pengagenda = data.pengagenda
        this.form.status_agenda = data.status_agenda
        this.form.tgl_agenda = data.tgl_agenda
        this.form.status = data.status

        this.form.status_verifikator = data.status_verifikator
        this.form.agenda_nomor = data.agenda_nomor

        this.form.user_nama = UMUM.namaLengkap(data.biodata_gelar_depan, data.biodata_nama, data.biodata_gelar_belakang);

        this.form.sm_verifikator_id = data.sm_verifikator_id;

        this.asyncFunc(data.id)

        // this.FETCHING.postBiodataAuto(this.unit_kerja, '')
        this.selectBiodata('');
    },


    searchUnitKerja : function(){
      this.FETCHING.postUnitKerjaSearch(this.filterku.unit_kerja_search)
    },

    asyncFunc : async function(surat_id){
      this.list_pemeriksa = await this.FETCHING.postOnePemeriksa(surat_id);
      this.list_penandatangan = await this.FETCHING.postOnepenandaTangan(surat_id);
      this.list_penerima_final = await this.FETCHING.postOnePenerima(surat_id);
    },


    selectBiodata : async function(value){
    //   console.log(value);
    //   this.FETCHING.postBiodataAuto(this.unit_kerja, value)
        this.list_penerima_view = await this.FETCHING.postSmPenerimaSurat(this.form.id)
        this.list_penerima_surat = await this.FETCHING.postBiodata(this.filterku.unit_kerja_id, this.filterku.cari_value, this.filterku.page_limit)
        console.log(this.list_penerima_view)
    },

    hapusSmPenerima : function(id){
        fetch(this.$store.state.url.office_sm_verifikasiDisposisi + "hapusSmPenerima", {
            method: "POST",
            headers: {
                "content-type": "application/json",
                authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify({id : id, tess : 'xxx'})
        }).then(res_data => {
            this.Notify('Sukses Menghapus Data', 'negative', 'check_circle_outline');
            this.selectBiodata();
        });
    },

    filterUnitKerja : function (val, update, abort) {
        update(() => {
          if (val === '') {}
          else {FETCHING.postUnitKerjaAuto(val)}
        })
    },

    CheckBiodataPenerima : function(){

    },

    





    // ====================================== PAGINATE ====================================
        Notify : function(message, positive, icon){
          this.$q.notify({
            message: message,
            color: positive,
            icon: icon,
            position : 'top',
            timeout: 500,
          })
        },
        btn_prev : function(){
            this.cek_load_data = true;
            if(this.page_first>1){
                this.page_first--
            }else{
                this.page_first = 1;
            }
            this.getView();
        },

        btn_next : function(){
            if(this.page_first >= this.page_last){
                this.page_first == this.page_last
            }else{
                this.page_first++;
            }
            this.getView();
        },

        cari_data : function(){
            this.page_first = 1;
            this.getView();
        },

        

    // ====================================== PAGINATE ====================================







  },

  mounted () {

    var get_profile = JSON.parse(localStorage.profile);
    this.form.unit_kerja = get_profile.profile.unit_kerja;
    this.unit_kerja = get_profile.profile.unit_kerja;

    this.filterku.unit_kerja_id = get_profile.profile.unit_kerja;

    

    this.FETCHING.getBentuk();
    this.FETCHING.getSifat();
    this.FETCHING.getBorang();

    this.FETCHING.postUnitKerjaAuto('')
    // this.FETCHING.postBiodataAuto(this.unit_kerja,'')
    this.selectBiodata('')

    this.getView();

  },
}
